import { render, staticRenderFns } from "./MilitaryStatusTypeAdd.vue?vue&type=template&id=d364783a&"
import script from "./MilitaryStatusTypeAdd.vue?vue&type=script&lang=js&"
export * from "./MilitaryStatusTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports